import React from 'react'
import { Link } from 'gatsby'

const HomeContact = ({ heading, content, id }) => {
  return (
    <div
      id={id}
      className='lg:p-[40px] md:py-[45px] md:container p-[10px] bg-black-100'
    >
      <div className='lg:gap-[40px] lg:py-[140px] md:pt-[68px] md:gap-[38px] flex flex-col items-center gap-[30px] text-center px-[14px] pt-[64px] pb-[46px] bg-white'>
        <h2
          className='md:text-5xl text-3xl'
          data-aos='fade-up'
          data-aos-duration='500'
          data-aos-easing='ease-in-out'
        >
          {heading}
        </h2>
        <p
          className='lg:max-w-[800px] md:max-w-[550px] text-lg'
          data-aos='fade-up'
          data-aos-duration='500'
          data-aos-easing='ease-in-out'
        >
          {content}
        </p>
        <Link
          to='/company'
          className='secondary-button px-[64px] py-[26px] self-center'
          data-aos='fade-up'
          data-aos-duration='500'
          data-aos-easing='ease-in-out'
        >
          Read More
        </Link>
      </div>
    </div>
  )
}

export default HomeContact
